import classes from "../../styles/Backdrop.module.css";
import { getClasses } from "../../utils";
import { useAppSelector, useAnimations } from "../../hooks";
import { useEffect, useState, useRef } from "react";

const Backdrop: React.FC<{}> = () => {
  const backdrop = useAppSelector((state) => state.modals.backdrop);
  const [visible, setVisible] = useState(backdrop);
  const [initialized, setInitialized] = useState(false);
  const backdropRef = useRef(null);

  const animations = {
    show: {
      duration: 0.3,
      opacity: 1,
      ease: "power3.out",
      atStart: setVisible.bind(null, true),
      atEnd: setInitialized.bind(null, true)
    },
    hide: {
      duration: 0.3,
      opacity: 0,
      atEnd: setVisible.bind(null, false),
    },
  };

  const [animationClass, setAnimation] = useAnimations(
    animations,
    "modal-backdrop",
    backdropRef
  );

  useEffect(() => {
    if ((backdrop && visible) || (!backdrop && !initialized)) return;

    setAnimation(backdrop ? "show" : "hide");
  }, [backdrop]);

  return visible ? (
    <div
      ref={backdropRef}
      className={getClasses(classes, "backdrop", animationClass)}
    ></div>
  ) : null;
};

export default Backdrop;
